export function priceFloat(num) {
  let number = parseInt(num)
  return number.toFixed(2)
}

export function expression(str) {
  RongIMLib.RongIMEmoji.init();
  return RongIMLib.RongIMEmoji.symbolToEmoji(str)
}